module.exports = __webpack_public_path__ + "static/media/corporate-services-img41.52001767.jpg";